export const deriveInitalValues = (tName:string|undefined,noOfRecords:number|undefined|null) => {
    return {
        tname:tName?tName:"",
        no_of_records:noOfRecords?noOfRecords:''
    }
}